import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme:any) => ({
  root: {
    width: '100%',
    margin: 0,
    gap: '0px',
    flex: 1,
    minHeight: 0,
  },
  room: {
    padding: theme.spacing(1.5),
    // maxHeight: '100%',
    gap: '10px',
    // scrollbarWidth: 'thin',
  },
  messageListContainer: {
    width: '100%',
    overflow: 'scroll',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    boxSizing: 'border-box',
    height: '100%',
    gap: '12px',
  },
  messageItem: {
    backgroundColor: 'rgba(239, 239, 240, 0.5)',
    padding: '15px',
    borderRadius: '5px',
    gap: '10px'
  },
  messageContainer: {
    maxHeight: '50%',
    // flex: 1,
  },
  message: {
    border: '1px solid lightgray',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
  questionText: {
    overflow: 'scroll',
    overflowX: 'hidden',
    maxHeight: '100px',
  }
}));
